// import "../styles/FacilityHighlights.css";

// // dummy icons (you can replace with real images later)
// import facilityIcon from "../images/Facility.png";
// import sopIcon from "../images/SOP.png";
// import qualityIcon from "../images/Quality.png";
// import deliveryIcon from "../images/FastDelivery.png";

// export default function FacilityHighlights() {
//   return (
//     <section className="facility-section">

//       <div className="container">

//         {/* Header */}
//         <div className="facility-header">

//           <h2>Our Strengths</h2>

//           <p>
//             Built on strong systems, disciplined processes, and commitment
//             to quality manufacturing excellence.
//           </p>

//         </div>

//         {/* Grid */}
//         <div className="facility-grid">

//           <div className="facility-card">
//             <img src={facilityIcon} alt="facility" />
//             <h3>Advanced Facility</h3>
//           </div>

//           <div className="facility-card">
//             <img src={sopIcon} alt="sop" />
//             <h3>SOP Processes</h3>
//           </div>

//           <div className="facility-card">
//             <img src={qualityIcon} alt="quality" />
//             <h3>Quality Compliance</h3>
//           </div>

//           <div className="facility-card">
//             <img src={deliveryIcon} alt="delivery" />
//             <h3>Timely Delivery</h3>
//           </div>

//         </div>

//       </div>

//     </section>
//   );
// }







import "../styles/FacilityHighlights.css";

// dummy icons
import facilityIcon from "../images/Facility.png";
import sopIcon from "../images/SOP.png";
import qualityIcon from "../images/Quality.png";
import deliveryIcon from "../images/FastDelivery.png";

export default function FacilityHighlights() {
  return (
    <section className="facility-section">

      <div className="container">

        {/* Header */}
        <div className="facility-header">

          <h2>Our Strengths</h2>

          <p>
            Built on strong systems, disciplined processes, and commitment
            to quality manufacturing excellence.
          </p>

        </div>

        {/* Grid */}
        <div className="facility-grid">

          <div className="facility-card">
            <img src={facilityIcon} alt="facility" />
            <h3>Advanced Facility</h3>
          </div>

          <div className="facility-card">
            <img src={sopIcon} alt="sop" />
            <h3>SOP Processes</h3>
          </div>

          <div className="facility-card">
            <img src={qualityIcon} alt="quality" />
            <h3>Quality Compliance</h3>
          </div>

          <div className="facility-card">
            <img src={deliveryIcon} alt="delivery" />
            <h3>Timely Delivery</h3>
          </div>

        </div>

      </div>

    </section>
  );
}